import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon, TrophyIcon, ShoppingBagIcon, CoffeeIcon, TicketIcon } from 'lucide-react';
export function RewardsScreen() {
  const rewards = [{
    icon: ShoppingBagIcon,
    title: 'PKR 500 Voucher',
    points: 2500,
    color: '#10B981'
  }, {
    icon: CoffeeIcon,
    title: 'Free Coffee',
    points: 1000,
    color: '#F37024'
  }, {
    icon: TicketIcon,
    title: 'Movie Tickets',
    points: 3500,
    color: '#8B5CF6'
  }, {
    icon: GiftIcon,
    title: 'Gift Card PKR 1000',
    points: 5000,
    color: '#EF4444'
  }];
  const recentActivity = [{
    action: 'Earned 150 points',
    detail: 'Bill payment',
    date: 'Today'
  }, {
    action: 'Redeemed Coffee Voucher',
    detail: '-1000 points',
    date: 'Yesterday'
  }, {
    action: 'Earned 500 points',
    detail: 'Salary credit',
    date: 'Dec 28'
  }];
  return <motion.div initial={{
    opacity: 0,
    x: 20
  }} animate={{
    opacity: 1,
    x: 0
  }} exit={{
    opacity: 0,
    x: -20
  }} className="w-full min-h-screen bg-background pb-20" data-id="element-556">
      {/* Header */}
      <div className="bg-white px-6 py-5" data-id="element-557">
        <h1 className="text-xl font-bold text-textPrimary" data-id="element-558">Rewards</h1>
      </div>

      <div className="px-6 py-6 space-y-6" data-id="element-559">
        {/* Points Balance */}
        <div className="bg-gradient-to-br from-accent to-[#D95A1A] rounded-2xl p-6 shadow-lg relative overflow-hidden" data-id="element-560">
          <div className="absolute top-0 right-0 w-32 h-32 bg-white opacity-10 rounded-full -mr-16 -mt-16" data-id="element-561" />
          <div className="absolute bottom-0 left-0 w-24 h-24 bg-white opacity-10 rounded-full -ml-12 -mb-12" data-id="element-562" />

          <div className="relative z-10 flex items-center gap-4" data-id="element-563">
            <div className="w-16 h-16 bg-white bg-opacity-20 rounded-full flex items-center justify-center" data-id="element-564">
              <TrophyIcon className="w-8 h-8 text-white" strokeWidth={2} data-id="element-565" />
            </div>
            <div data-id="element-566">
              <p className="text-white text-opacity-90 text-sm mb-1" data-id="element-567">
                Available Points
              </p>
              <h2 className="text-3xl font-bold text-white" data-id="element-568">8,450</h2>
            </div>
          </div>
        </div>

        {/* Available Rewards */}
        <div data-id="element-569">
          <h3 className="text-base font-semibold text-textPrimary mb-4" data-id="element-570">
            Redeem Rewards
          </h3>
          <div className="space-y-3" data-id="element-571">
            {rewards.map((reward, index) => {
            const Icon = reward.icon;
            return <div key={index} className="bg-white rounded-2xl p-4 shadow-sm flex items-center gap-4" data-id="element-572">
                  <div className="w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0" style={{
                backgroundColor: `${reward.color}15`
              }} data-id="element-573">
                    <Icon className="w-6 h-6" style={{
                  color: reward.color
                }} strokeWidth={2} data-id="element-574" />
                  </div>
                  <div className="flex-1" data-id="element-575">
                    <h4 className="text-sm font-semibold text-textPrimary mb-1" data-id="element-576">
                      {reward.title}
                    </h4>
                    <p className="text-xs text-textSecondary" data-id="element-577">
                      {reward.points} points
                    </p>
                  </div>
                  <button className="px-4 py-2 bg-accent text-white text-sm font-semibold rounded-lg hover:bg-opacity-90 transition-all" data-id="element-578">
                    Redeem
                  </button>
                </div>;
          })}
          </div>
        </div>

        {/* Recent Activity */}
        <div data-id="element-579">
          <h3 className="text-base font-semibold text-textPrimary mb-4" data-id="element-580">
            Recent Activity
          </h3>
          <div className="bg-white rounded-2xl p-4 shadow-sm divide-y divide-gray-100" data-id="element-581">
            {recentActivity.map((activity, index) => <div key={index} className="py-3 first:pt-0 last:pb-0" data-id="element-582">
                <div className="flex items-start justify-between" data-id="element-583">
                  <div data-id="element-584">
                    <p className="text-sm font-medium text-textPrimary mb-1" data-id="element-585">
                      {activity.action}
                    </p>
                    <p className="text-xs text-textSecondary" data-id="element-586">
                      {activity.detail}
                    </p>
                  </div>
                  <span className="text-xs text-textSecondary" data-id="element-587">
                    {activity.date}
                  </span>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </motion.div>;
}